import React, { useState, useEffect } from "react";
import { Layout } from "antd";

import { MobileTab } from "./MobileTab";
import { HeaderMain } from "./Headers/HeaderMain";

interface Props {
  page: any;
  children: any;
}

function Template({ page, children }: Props) {
  const { Content } = Layout;
  const [menuCollapse, setMenuCollapse] = useState(false);

  const collapseMenu = () => {
    setMenuCollapse(!menuCollapse);
  };

  const nav = {
    navMenu: collapseMenu,
    currrentPage: page,
  };

  useEffect(() => {
    let touchstartX = 0;
    let touchendX = 0;

    function handleGesture() {
      const right = touchendX - touchstartX;
      const left = touchstartX - touchendX;

      if (touchendX < touchstartX && left > 300) {
        setMenuCollapse(false);
      }

      if (touchendX > touchstartX && right > 300) {
        setMenuCollapse(true);
      }
    }

    window.addEventListener("touchstart", (e) => {
      touchstartX = e.changedTouches[0].screenX;
    });

    window.addEventListener("touchend", (e) => {
      touchendX = e.changedTouches[0].screenX;
      handleGesture();
    });

    return () =>
      window.removeEventListener("touchend", (e) => {
        touchendX = e.changedTouches[0].screenX;
        handleGesture();
      });
  }, []);

 return (
  <React.Fragment>
    <div className="flex flex-col h-screen items-center gap-5 w-full overflow-y-auto">
      <div className="flex flex-col px-[1rem] items-center gap-5 w-full flex-grow">
        <HeaderMain {...nav} />
        <Content className="w-full">{children}</Content>
      </div>

      <div className="sticky bottom-0 left-0 right-0 w-full z-50">
        <MobileTab offset={0} limit={1} />
      </div>
    </div>
  </React.Fragment>
);
}

export default Template;